"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsGuard = void 0;
require("@veeam/core");
require("./types");
const PermissionsGuardRequest_1 = require("./PermissionsGuardRequest");
class PermissionsGuard {
    constructor(guardModel, policyList, subject) {
        this.guardModel = guardModel;
        this.policyList = policyList;
        this.subject = subject;
        this.can = (resourceName, action) => {
            var _a, _b;
            return ((_b = (_a = this.guardModel) === null || _a === void 0 ? void 0 : _a.effect(this.createRequest(resourceName, action), this.policyList || [])) !== null && _b !== void 0 ? _b : true);
        };
        this.createRequest = (resourceName, action) => {
            return new PermissionsGuardRequest_1.PermissionsGuardRequest(this.subject, resourceName, action);
        };
    }
}
exports.PermissionsGuard = PermissionsGuard;
//# sourceMappingURL=PermissionsGuard.js.map